import { render, staticRenderFns } from "./text-response.vue?vue&type=template&id=f5bd0798&"
import script from "./text-response.vue?vue&type=script&lang=js&"
export * from "./text-response.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "text-response.vue"
export default component.exports